import { render, staticRenderFns } from "./Stock-valorizado.vue?vue&type=template&id=e174bb08"
import script from "./Stock-valorizado.vue?vue&type=script&lang=js"
export * from "./Stock-valorizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports